import { render, staticRenderFns } from "./SubOrderContent.vue?vue&type=template&id=0fd26272&scoped=true&"
import script from "./SubOrderContent.vue?vue&type=script&lang=js&"
export * from "./SubOrderContent.vue?vue&type=script&lang=js&"
import style0 from "./SubOrderContent.vue?vue&type=style&index=0&id=0fd26272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd26272",
  null
  
)

/* custom blocks */
import block0 from "./SubOrderContent.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports